var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "375pt",
    height: "374.999991pt",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80.25 37.5 L 294.75 37.5 L 294.75 337.5 L 80.25 337.5 Z M 80.25 37.5 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509277%,17.248535%,24.308777%)",
      fillOpacity: 1
    },
    d: "M 61.980469 375 L 313.019531 375 C 347.195312 375 375 347.195312 375 313.019531 L 375 61.980469 C 375 27.804688 347.195312 0 313.019531 0 L 61.980469 0 C 27.804688 0 0 27.804688 0 61.980469 L 0 313.019531 C 0 347.195312 27.804688 375 61.980469 375 Z M 61.980469 375 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 187.527344 51.273438 C 239.140625 51.273438 281.136719 93.265625 281.136719 144.882812 C 281.136719 163.699219 267.75 196.519531 242.429688 239.800781 C 221.207031 276.074219 197.03125 310.378906 187.527344 323.566406 C 178.019531 310.371094 153.84375 276.066406 132.625 239.800781 C 107.304688 196.519531 93.917969 163.699219 93.917969 144.882812 C 93.917969 93.265625 135.910156 51.273438 187.527344 51.273438 Z M 176.535156 331.667969 C 179.113281 335.246094 183.121094 337.296875 187.527344 337.296875 C 191.933594 337.296875 195.941406 335.246094 198.515625 331.667969 C 210.609375 314.890625 234.019531 281.375 254.925781 245.449219 C 281.378906 199.992188 294.792969 166.15625 294.792969 144.882812 C 294.792969 85.738281 246.671875 37.621094 187.527344 37.621094 C 128.382812 37.621094 80.261719 85.738281 80.261719 144.882812 C 80.261719 166.15625 93.675781 199.992188 120.128906 245.449219 C 141.03125 281.371094 164.441406 314.890625 176.535156 331.667969 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 187.527344 88.644531 C 218.535156 88.644531 243.765625 113.875 243.765625 144.882812 C 243.765625 175.890625 218.535156 201.121094 187.527344 201.121094 C 156.519531 201.121094 131.292969 175.890625 131.292969 144.882812 C 131.292969 113.875 156.519531 88.644531 187.527344 88.644531 Z M 187.527344 214.773438 C 226.066406 214.773438 257.417969 183.421875 257.417969 144.882812 C 257.417969 106.34375 226.066406 74.992188 187.527344 74.992188 C 148.992188 74.992188 117.636719 106.34375 117.636719 144.882812 C 117.636719 183.421875 148.992188 214.773438 187.527344 214.773438 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.bb6299d9cf5f75c1b98f186719cf2b74.svg";
export { ForwardRef as ReactComponent };